const adIds = {
  mediumRectangle: 'SPM_Incontent-1',
  superbanner: 'SPM_Incontent-2',
  sonderwerbemittel: 'SPM_Sonderwerbemittel',
}

const adPageTypes = [
  {
    pattern: /^\/$/,
    title: 'allgemein',
  },
  {
    pattern: /^\/en\/home$/,
    title: 'en-startseite',
  },
  {
    pattern: /\/maenner\/nationalmannschaften\/nationalmannschaft(?:\/.*)?$/,
    title: 'a-nationalmannschaft',
  },
  {
    pattern: /\/frauen\/nationalmannschaften(?:\/.*)?$/,
    title: 'frauen-nationalmannschaft',
  },
  {
    pattern: /\/maenner\/nationalmannschaften\/u-?(?:\d+)(?:\/.*)?$/,
    title: 'u-mannschaften',
  },
  {
    pattern: /\/maenner\/wettbewerbe\/dfb-pokal(?:\/.*)?$/,
    title: 'dfb-maenner-pokal',
  },
  {
    pattern: /\/frauen(?:\/.*)?$/,
    title: 'dfb-frauen-pokal-ligen',
  },
  {
    pattern: /\/maenner\/ligen\/3-liga(?:\/.*)?$/,
    title: 'mannschaften-dritte-liga',
  },
  {
    pattern: /\/fans(?:\/.*)?$/,
    title: 'fans',
  },
  {
    pattern: /\/adventsaktion(?:\/.*)?$/,
    title: 'adventsaktion',
  },
]

export const getAdPageType = (slug: string) => {
  for (const { pattern, title } of adPageTypes) {
    if (slug.match(pattern)) {
      return title
    }
  }

  return adPageTypes[0].title
}

export const getAdId = (format: 'superbanner' | 'mediumRectangle' | 'sonderwerbemittel') => {
  return adIds[format]
}
